import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { get, post } from "../../services/smartApiService";
import { DASHBOARD_URL } from "../../api/AdminUrls";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

interface piechartprops {
  title?: string;
  url: string;
}

const sampleData = [
  {
    label: ">70",
    data: 1290,
    backgroundColor: "dodgerblue",
  },
  {
    label: "> 50",
    data: 2370,
    backgroundColor: "#f97a67",
  },
  {
    label: "< 50",
    data: 2370,
    backgroundColor: "#f97bc4",
  },
];

const UsersPieChart: React.FC<piechartprops> = ({ title, url }) => {
  const [chartData, setChartData] = useState<any[]>([]);


  const loadTableData = () => {
    let URL = DASHBOARD_URL.GET_TRAINEE_SCORES;
    const subscription = get(URL).subscribe((response) => {

      const mergedData = [
        { label: ">70", data: response.data.above_70, backgroundColor: "dodgerblue" },
        { label: "50-70", data: response.data.between_50_70, backgroundColor: "#f97a67" },
        { label: "<50", data: response.data.below_50, backgroundColor: "#f97bc4" },
      ];
      setChartData(mergedData );
       console.log("Score Response",response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);
  


  const data = {
    labels: chartData.map((item) => item.label),
    datasets: [
      {
        data: chartData.map((item) => item.data),
        backgroundColor: chartData.map((item) => item.backgroundColor),
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top" as const,
      },
      tooltip: {
        callbacks: {
          label: (context: any) => `${context.label}: ${context.raw}`,
        },
      },
    },
  };

  return (
    <>
      <div className="flex-between mb-2 p-1">
        <div className="is-size-6 has-text-weight-bold">{title ?? ""}</div>
      </div>
      <div className="chart-container">
        <Pie data={data} options={options} height={200} />
      </div>
    </>
  );
};

export default UsersPieChart;
